import { GetStaticProps, NextPage } from "next"
import { loadStaticProps, Component, PageProps } from "@/pages-shared/listing"

const Page: NextPage<PageProps> = (props) => (
  <Component basePath="components" title="Components" {...props} />
)

export const getStaticProps: GetStaticProps = async (context) => {
  return {
    props: await loadStaticProps(context, "components"),
    revalidate: 24 * 60 * 60,
  }
}

export default Page
